import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function SleeveLogoDigitizing() {

    const sleeveSteps = [
        { number: "01", title: "Submit Your Logo", description: "Send your design in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Sleeve Digitizing", description: "We create a machine-ready embroidery file optimized for sleeve placement.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "Refine stitch paths, density, and size for clean embroidery results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, and other compatible formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Sleeve Logo Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Professional sleeve logo digitizing services in Los Angeles, CA. Clean and precise embroidery files for sleeves and apparel." />
                <meta name="keywords" content="sleeve logo digitizing, sleeve embroidery digitizing, embroidery digitizing services, Los Angeles digitizing services, embroidery near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Sleeve Logo Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Sleeve Logo Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/sleevslogo1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Compact Design. Maximum Impact.</span>
                                <h3 className="case-study-title">Expert Sleeve Logo Digitizing in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we specialize in sleeve logo digitizing services in Los Angeles, California, creating precise embroidery files for designs placed on sleeves. Sleeve embroidery requires careful attention to stitch direction, design size, and fabric type to ensure clean, professional results without distortion.
                                </p>
                                <p className="case-study-description">
                                    Our team converts your logos, text, or artwork into machine-ready stitch files optimized for sleeve placement. Whether it’s for corporate uniforms, sports apparel, or branded clothing, our sleeve embroidery digitizing services ensure every stitch is accurate and visually appealing. If you’re searching for reliable sleeve logo digitizing near you in Los Angeles, Grand Indigo Embroidery provides professional, high-quality results every time.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Optimized for Small-Scale Precision</span>
                                <h3 className="case-study-title">Custom Sleeve Digitizing for Apparel & Uniforms</h3>
                                <p className="case-study-description">
                                    Our custom sleeve logo digitizing services are designed to handle all types of embroidery designs, from small text to detailed logos. We optimize stitch paths, density, and design placement to maintain clarity and reduce thread breaks, ensuring your sleeve embroidery looks perfect on every garment.
                                </p>
                                <p className="case-study-description">
                                    Businesses across Los Angeles trust us for fast, reliable service and professional results. You can also order sleeve logo digitizing online to receive fully optimized embroidery files ready for production, making it easy to enhance uniforms, team apparel, and promotional items with high-quality sleeve embroidery.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/sleevslogo2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={sleeveSteps} />
                                                
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is sleeve logo digitizing?"
                                    answer="Sleeve logo digitizing is the process of converting designs into machine-readable embroidery files optimized for sleeve placement on garments."
                                />

                                <FaqItem
                                    question="Do you offer sleeve logo digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional sleeve logo digitizing services in Los Angeles, California."
                                />

                                <FaqItem
                                    question="How long does sleeve logo digitizing take?"
                                    answer="Most sleeve embroidery designs are digitized within 12–24 hours depending on complexity."
                                />

                                <FaqItem
                                    question="Can I order sleeve logo digitizing online?"
                                    answer="Yes, you can easily order sleeve logo digitizing online with fast and reliable service."
                                />

                                <FaqItem
                                    question="What garments can be embroidered on sleeves?"
                                    answer="Sleeve embroidery can be applied to shirts, jackets, polos, hoodies, and uniforms."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
